{
    "internalApiBaseUrl": "https://velocityapi-app.newton.ca/api/internal",
    "publicApiBaseUrl": "https://velocityapi-app.newton.ca/api/public",
    "assetsUrl": "https://velocity-app.newton.ca/app/en/assets",
    "sharedAssetsUrl": "https://velocity-app.newton.ca/assets",
    "externalLoginUrl": "https://velocity.newton.ca",
    "debugConsoleEnabled": false,
    "auth0": {
        "domain": "auth-velocity-client.newton.ca",
        "clientId": "4gVtnYPY21E8ojS01qHDl5lbRtDNi1yr",
        "authorizationParams": {
            "audience": "https://client-journey.api"
        },
        "redirectUriExpiryTimeSpan": 432000000,
        "httpInterceptor": {
            "allowedList": [
                {
                    "uri": "https://velocityapi-app.newton.ca/api/public/v2/*",
                    "allowAnonymous": true
                }
            ]
        }
    },
    "flinks": {
        "environmentName": "newton",
        "connectUrl": "https://newton-iframe.private.fin.ag/",
        "customerId": "07fa8d68-18b6-49c1-8f88-23caf5237451",
        "demoMode": false
    }
}